export const markAsUnread = "KF8hFd";
export const markAsUnreadNumberOfConversationsWhenCountIsNegative = "_Tclr";
export const markAsUnreadNumberOfItemsWhenCountIsNegative = "si4fae";
export const markAsUnreadNumberOfConversations = "YiMnbc";
export const markAsUnreadNumberOfItems = "Au5Edd";
export default {markAsUnread,markAsUnreadNumberOfConversationsWhenCountIsNegative,markAsUnreadNumberOfItemsWhenCountIsNegative,markAsUnreadNumberOfConversations,markAsUnreadNumberOfItems};